module.exports = __webpack_public_path__ + "static/media/b23@2x.dfbb6965.png";